import React from 'react';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../core/common/imageWithBasePath';
import { TableData } from '../../core/data/interface';
import { contactMessagesData } from '../../core/data/json/contactMessages';
import Table from '../../core/common/dataTable/index';
import PredefinedDateRanges from '../../core/common/datePicker';
import CommonSelect from '../../core/common/commonSelect';
import {
  contactMess,
  contactMessOne,
} from '../../core/common/selectoption/selectoption';
import { DatePicker } from 'antd';

const ContactMessages = () => {
  const data = contactMessagesData;
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      render: (text: string, record: any, index: number) => (
        <>
          <Link to='#' className='link-primary'>
            {record.id}
          </Link>
        </>
      ),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      render: (text: string, record: any) => (
        <div className='d-flex align-items-center'>
          <Link to='#' className='avatar avatar-md'>
            <ImageWithBasePath
              src={record.img}
              className='img-fluid rounded-circle'
              alt='img'
            />
          </Link>
          <div className='ms-2'>
            <p className='text-dark mb-0'>
              <Link to='#'>{record.name}</Link>
            </p>
          </div>
        </div>
      ),
      sorter: (a: TableData, b: TableData) => a.name.length - b.name.length,
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      sorter: (a: TableData, b: TableData) => a.phone.length - b.phone.length,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      sorter: (a: TableData, b: TableData) => a.email.length - b.email.length,
    },
    {
      title: 'Message',
      dataIndex: 'message',
      sorter: (a: TableData, b: TableData) =>
        a.message.length - b.message.length,
    },
    {
      title: 'Date',
      dataIndex: 'date',
      sorter: (a: TableData, b: TableData) => a.date.length - b.date.length,
    },
    {
      title: 'Action',
      dataIndex: 'action',
      render: () => (
        <>
          <div className='d-flex align-items-center'>
            <div className='dropdown'>
              <Link
                to='#'
                className='btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0'
                data-bs-toggle='dropdown'
                aria-expanded='false'
              >
                <i className='ti ti-dots-vertical fs-14' />
              </Link>
              <ul className='dropdown-menu dropdown-menu-right p-3'>
                <li>
                  <Link
                    className='dropdown-item rounded-1'
                    to='#'
                    data-bs-toggle='modal'
                    data-bs-target='#edit_messages'
                  >
                    <i className='ti ti-edit-circle me-2' />
                    Edit
                  </Link>
                </li>
                <li>
                  <Link
                    className='dropdown-item rounded-1'
                    to='#'
                    data-bs-toggle='modal'
                    data-bs-target='#delete-modal'
                  >
                    <i className='ti ti-trash-x me-2' />
                    Delete
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <div>
      <div className='page-wrapper'>
        <div className='content'>
          {/* Page Header */}
          <div className='d-md-flex d-block align-items-center justify-content-between mb-3'>
            <div className='my-auto mb-2'>
              <h3 className='page-title mb-1'>Contact Messages</h3>
              <nav>
                <ol className='breadcrumb mb-0'>
                  <li className='breadcrumb-item'>
                    <Link to='index'>Dashboard</Link>
                  </li>
                  <li className='breadcrumb-item'>
                    <Link to='#'>Support</Link>
                  </li>
                  <li className='breadcrumb-item active' aria-current='page'>
                    Contact Messages
                  </li>
                </ol>
              </nav>
            </div>
            <div className='d-flex my-xl-auto right-content align-items-center flex-wrap'>
              <div className='mb-2'>
                <Link
                  to='#'
                  className='btn btn-primary d-flex align-items-center'
                  data-bs-toggle='modal'
                  data-bs-target='#add_messages'
                >
                  <i className='ti ti-square-rounded-plus me-2' />
                  Add Message
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Filter Section */}
          <div className='card'>
            <div className='card-header d-flex align-items-center justify-content-between flex-wrap pb-0'>
              <h4 className='mb-3'>Contact Messages List</h4>
              <div className='d-flex align-items-center flex-wrap'>
                <div className='input-icon-start mb-3 me-2 position-relative'>
                  <PredefinedDateRanges />
                </div>
                <div className='dropdown mb-3 me-2'>
                  <Link
                    to='#'
                    className='btn btn-outline-light bg-white dropdown-toggle'
                    data-bs-toggle='dropdown'
                    data-bs-auto-close='outside'
                  >
                    <i className='ti ti-filter me-2' />
                    Filter
                  </Link>
                  <div className='dropdown-menu drop-width'>
                    <form>
                      <div className='d-flex align-items-center border-bottom p-3'>
                        <h4>Filter</h4>
                      </div>
                      <div className='p-3 pb-0 border-bottom'>
                        <div className='row'>
                          <div className='col-md-12'>
                            <div className='mb-3'>
                              <label className='form-label'>Questions</label>
                              <CommonSelect
                                className='select'
                                options={contactMess}
                                defaultValue={undefined}
                              />
                            </div>
                          </div>
                          <div className='col-md-12'>
                            <div className='mb-3'>
                              <label className='form-label'>Category</label>
                              <CommonSelect
                                className='select'
                                options={contactMessOne}
                                defaultValue={undefined}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='p-3 d-flex align-items-center justify-content-end'>
                        <Link to='#' className='btn btn-light me-3'>
                          Reset
                        </Link>
                        <button type='submit' className='btn btn-primary'>
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div className='dropdown mb-3'>
                  <Link
                    to='#'
                    className='btn btn-outline-light bg-white dropdown-toggle'
                    data-bs-toggle='dropdown'
                  >
                    <i className='ti ti-sort-ascending-2 me-2' />
                    Sort by A-Z
                  </Link>
                  <ul className='dropdown-menu p-3'>
                    <li>
                      <Link to='#' className='dropdown-item rounded-1 active'>
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to='#' className='dropdown-item rounded-1'>
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link to='#' className='dropdown-item rounded-1'>
                        Recently Viewed
                      </Link>
                    </li>
                    <li>
                      <Link to='#' className='dropdown-item rounded-1'>
                        Recently Added
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='card-body p-0 py-3'>
              {/* Contant Message */}
              <Table columns={columns} dataSource={data} Selection={true} />
              {/* /Contant Message */}
            </div>
          </div>
          {/* /Filter Section */}
        </div>
      </div>
      <>
        {/* Add Contact Message */}
        <div className='modal fade' id='add_messages'>
          <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h4 className='modal-title'>Add Contact Messages</h4>
                <button
                  type='button'
                  className='btn-close custom-btn-close'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  <i className='ti ti-x' />
                </button>
              </div>
              <form>
                <div className='modal-body'>
                  <div className='row'>
                    <div className='col-md-12'>
                      <div className='mb-3'>
                        <label className='form-label'>Name</label>
                        <input type='text' className='form-control' />
                      </div>
                      <div className='mb-3'>
                        <label className='form-label'>Email</label>
                        <input type='text' className='form-control' />
                      </div>
                      <div className='mb-3'>
                        <label className='form-label'>Phone</label>
                        <input type='text' className='form-control' />
                      </div>
                      <div className='mb-3'>
                        <label className='form-label'>Message</label>
                        <input type='text' className='form-control' />
                      </div>
                      <div className='mb-3'>
                        <label className='form-label'>Date</label>
                        <div className='input-icon position-relative'>
                          <span className='input-icon-addon'>
                            <i className='ti ti-calendar' />
                          </span>
                          <DatePicker
                            className='form-control datetimepicker'
                            placeholder='Select Date'
                          />
                        </div>
                      </div>
                      <div className='d-flex align-items-center justify-content-between'>
                        <div className='status-title'>
                          <h5>Status</h5>
                          <p>Change the Status by toggle </p>
                        </div>
                        <div className='form-check form-switch'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            role='switch'
                            id='switch-sm'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='modal-footer'>
                  <Link
                    to='#'
                    className='btn btn-light me-2'
                    data-bs-dismiss='modal'
                  >
                    Cancel
                  </Link>
                  <Link
                    to='#'
                    className='btn btn-primary'
                    data-bs-dismiss='modal'
                  >
                    Add messages
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Add Contact Message */}
        {/* Edit Contact Message */}
        <div className='modal fade' id='edit_messages'>
          <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h4 className='modal-title'>Edit Contact Messages</h4>
                <button
                  type='button'
                  className='btn-close custom-btn-close'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  <i className='ti ti-x' />
                </button>
              </div>
              <form>
                <div className='modal-body'>
                  <div className='row'>
                    <div className='col-md-12'>
                      <div className='mb-3'>
                        <label className='form-label'>Name</label>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Enter name'
                          defaultValue='Teresa'
                        />
                      </div>
                      <div className='mb-3'>
                        <label className='form-label'>Email</label>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Enter Email'
                          defaultValue='teresa@example.com'
                        />
                      </div>
                      <div className='mb-3'>
                        <label className='form-label'>Phone</label>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Enter Phone Number'
                          defaultValue='+1 82392 37359	'
                        />
                      </div>
                      <div className='mb-3'>
                        <label className='form-label'>Message</label>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Enter Message'
                          defaultValue='Reminder: Staff meeting tomorrow.'
                        />
                      </div>
                      <div className='mb-3'>
                        <label className='form-label'>Date</label>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Enter Date'
                          defaultValue='25 Mar 2024'
                        />
                      </div>
                      <div className='d-flex align-items-center justify-content-between'>
                        <div className='status-title'>
                          <h5>Status</h5>
                          <p>Change the Status by toggle </p>
                        </div>
                        <div className='form-check form-switch'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            role='switch'
                            id='switch-sm2'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='modal-footer'>
                  <Link
                    to='#'
                    className='btn btn-light me-2'
                    data-bs-dismiss='modal'
                  >
                    Cancel
                  </Link>
                  <Link
                    to='#'
                    className='btn btn-primary'
                    data-bs-dismiss='modal'
                  >
                    Save Cganges
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Add Contact Message */}
        {/* Delete Modal */}
        <div className='modal fade' id='delete-modal'>
          <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content'>
              <form>
                <div className='modal-body text-center'>
                  <span className='delete-icon'>
                    <i className='ti ti-trash-x' />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className='d-flex justify-content-center'>
                    <Link
                      to='#'
                      className='btn btn-light me-3'
                      data-bs-dismiss='modal'
                    >
                      Cancel
                    </Link>
                    <Link
                      to='#'
                      className='btn btn-danger'
                      data-bs-dismiss='modal'
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
      </>
    </div>
  );
};

export default ContactMessages;
